import type { LogRecord, Sink } from "@logtape/logtape";
import { getRum } from "~/rumClient";

/**
 * Browser counterpart to the server's event sink: `log.event` becomes a RUM
 * custom event of the same name. No-ops until `initRum` has run.
 */
export const getRumSink = (): Sink => (record: LogRecord) => {
  const { event, ...data } = record.properties;
  if (typeof event !== "string") return;

  getRum()?.recordEvent(event, data);
};
